import Vue from 'vue'

Vue.filter('showPrice', (number = 0) => {
  const num = parseFloat(number)
  if (num === 0 || num) {
    return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return '-'
})
